import AppRoutes from '@/routes/AppRoutes';
import ComponentNavigation from '@/navigation/ComponentNavigation'
import PublicNavigation from '@/navigation/PublicNavigation'
import { useSsoLogin } from '@gyandiksha/shared-ui/hooks';

const App = () => {

  // This will handle the ERP User SSO login process.
  const isERPUserLoginReady = useSsoLogin();

  if (!isERPUserLoginReady) {
    return null;
  }

  return (
    <div>
      <AppRoutes componentRoutes={ComponentNavigation} publicRoutes={PublicNavigation} />
    </div>
  )
}

export default App
